import { Box, SxProps, Theme } from "@mui/material";

export type TypeInfoRootProps = {
  children: React.ReactNode;
  width?: number | string;
  heigth?: number | string;
  backgroundColor?: string;
  sx?: SxProps<Theme>;
};

export function TypeInfoRoot({
  children,
  width,
  heigth,
  backgroundColor,
  sx,
}: TypeInfoRootProps) {
  return (
    <Box
      width={width}
      height={heigth}
      sx={{
        paddingRight: "5px",
        paddingLeft: "4px",
        borderRadius: "4px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: backgroundColor,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
